import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './BoardMembers.css';

const BoardMembers = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['मंडळ सदस्य', 'अधिकार', 'कार्ये', 'नियुक्ती', 'अधिसूचना'],
    en: ['board members', 'powers', 'functions', 'appointment', 'notification']
  });

  const pageHeaderData = {
    title: {
      marathi: 'मंडळ सदस्य',
      english: 'Board Members'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाचे सदस्य',
      english: 'Members of Maharashtra Labour Welfare Board'
    }
  };

  return (
    <div className="board-members">
      <div className="board-members-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="board-members-content" data-read-section="board-members-content">
          {/* Board Members Table */}
          <section className="board-members-section" data-read-section="board-members-table">
            <div className="board-members-table-container">
              <table className="board-members-table">
                <thead>
                  <tr>
                    <th>
                      {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
                    </th>
                    <th>
                      {isMarathi() ? 'तपशील' : 'Details'}
                    </th>
                    <th>
                      {isMarathi() ? 'परिपत्रक' : 'Circular'}
                    </th>
                    <th>
                      {isMarathi() ? 'दिनांक' : 'Date'}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="board-member-serial">
                      {isMarathi() ? '१' : '1'}
                    </td>
                    <td className="board-member-details">
                      {isMarathi() ? 'महाराष्ट्र कामगार कल्याण मंडळाचे अधिकार आणि कार्ये पार पाडण्यासाठी उप सचिव (कामगार-१०) यांच्या नियुक्तीबाबत' : 'Regarding the appointment of the Deputy Secretary (Labour-10) to exercise the powers and perform the functions of the Maharashtra Labour Welfare Board.'}
                    </td>
                    <td className="board-member-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/board-members/regarding-the-appointment-of-the-deputy-secretary-labour-10-to-exercise-the-powers-and-perform-the-functions-of-the-MLWB.pdf" 
                        className="board-member-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="board-member-date">
                      {isMarathi() ? '२९/०९/२०२५' : '29/09/2025'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="board-member-serial">
                      {isMarathi() ? '२' : '2'}
                    </td>
                    <td className="board-member-details">
                      {isMarathi() ? 'अधिसूचना - महाराष्ट्र कामगार कल्याण मंडळाचे अधिकार हस्तांतरण' : 'Notification - Transfer of powers of the Maharashtra Labour Welfare Board'}
                    </td>
                    <td className="board-member-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/board-members/notification-24.09.2025-MLWB-power-delegation.pdf" 
                        className="board-member-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="board-member-date">
                      {isMarathi() ? '२४/०९/२०२५' : '24/09/2025'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BoardMembers;

